import types from './constant';

export const setDialogState = data => ({
  type: types.FIELD_MODEL_DIALOG_SET_STATE,
  payload: data
});
